import React from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';

import { connect } from 'react-redux';

import Dropdown from 'components/dropdown';
import confirm from 'components/confirm';
import PhotoOrInitials from 'components/photo_or_initials';
import TaggedBody from 'bundles/apex/deals/tagged_body';
import { formatDate, TIME_FORMAT } from 'helpers/formatters/date_time_formats';

export function DealComment({ comment, forUser, today, onDelete, onEdit }) {
  const { createdAt, updatedAt, user } = comment;

  let createdAtString = formatDate(createdAt, TIME_FORMAT);
  if (!today) {
    createdAtString = `${formatDate(createdAt, 'MMM D')}, ${createdAtString}`;
  }

  const updatedAtString = formatDate(updatedAt, `MMM D, ${TIME_FORMAT}`);

  const deleteComment = () => {
    confirm('Are you sure you want to delete this comment?', {
      buttonLabel: 'Delete',
      buttonStyle: 'danger',
      title: `Delete Comment?`
    }).then(async () => {
      onDelete(comment);
    });
  };

  const isForUser = user.id == forUser.id;

  return (
    <div
      className={classNames('d-flex align-items-start gap-2', {
        'flex-row-reverse': isForUser,
      })}
    >
      <div className="d-flex flex-column gap-2">
        <PhotoOrInitials user={user} />
        {isForUser &&
          <Dropdown>
            <Dropdown.Item isEdit onClick={onEdit} />
            <Dropdown.Item isDelete onClick={deleteComment} />
          </Dropdown>
        }
      </div>

      <div
        className={classNames('d-flex flex-column justify-content-center gap-1', {
          'align-items-end': isForUser,
          'align-items-start': !isForUser,
        })}
      >
        <div
          className={classNames('d-flex gap-1 mt-2 fs-xs', {
            'flex-row-reverse': isForUser,
          })}
        >
          <div>{user.name}</div>
          <div className="text-muted">{createdAtString}</div>
        </div>

        <div
          className={classNames('d-flex flex-column', {
            'align-items-end': isForUser,
            'align-items-start': !isForUser,
          })}
        >
          <div
            className={classNames('py-2 px-4 rounded shadow-lg', {
              'bg-info-subtle': isForUser,
              'bg-light': !isForUser,
            })}
          >
            <TaggedBody bodyParts={comment.bodyParts} />
          </div>

          {comment.createdAt !== updatedAt &&
            <div className="text-muted fs-xs mt-1">(edited {updatedAtString})</div>
          }
        </div>
      </div>
    </div>
  );
}

DealComment.propTypes = {
  comment: PropTypes.shape({
    bodyParts: PropTypes.array,
    createdAt: PropTypes.string.isRequired,
    user: PropTypes.shape({
      name: PropTypes.string,
    }).isRequired
  }),
  forUser: PropTypes.shape({
    id: PropTypes.number.isRequired
  }),
  today: PropTypes.bool,
  onDelete: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
};

const mapStateToProps = ({ forUser }) => ({
  forUser
});

export default connect(mapStateToProps)(DealComment);
